// スクロールでアニメーションを設定
// トリガ：_js-scroll-animation-trigger
$(window).on('scroll', function () {
  $('._js-scroll-animation-trigger').each(function (index, elem) {
    var targetTop = $(elem).offset().top;
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scrollTop > targetTop - windowHeight + 200) {
      $(elem).addClass('_js-scroll-animation-on');
    }
  });
}); // トップの KV はスクロールではなくロードをトリガにアニメーションさせる

$(window).on('load', function () {
  $('._js-load-animation-trigger').each(function (index, elem) {
    $(elem).addClass('_js-load-animation-on');
  });
});